import { ReactNode } from 'react';
import styled from 'styled-components';

import { NorlysFont } from '~src/branding';
import { SavingsProps, useSavingsEstimate } from '~src/hooks/useSavings';

import { CompactTakeoverNorlys } from '../InfoBox/Takeover/norlys';

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '100%',
  padding: '24px 24px 8px 24px',
  borderRadius: '24px',
});

const ItemContainer = styled.div({ width: '100%' });

export const CompactSavingsWidgetNorlys = (
  props: SavingsProps & { children?: ReactNode; backgroundColor?: string }
) => {
  const { style, takeover, residence } = props;

  const { entries } = useSavingsEstimate({ ...props, compact: true });

  const backgroundColor = 'white';

  const headerTextStyle = { ...NorlysFont.style('default', 14) };
  const bodyTextStyle = { ...NorlysFont.style('heading', 26) };

  if (takeover) {
    return (
      <Wrapper style={{ ...style, backgroundColor }}>
        <CompactTakeoverNorlys takeover={takeover} residence={residence} />
      </Wrapper>
    );
  }

  return (
    <Wrapper style={{ ...style, backgroundColor }}>
      <ItemContainer style={{ display: 'flex', justifyContent: 'space-around' }}>
        {entries.map(({ label, value }) => (
          <div style={{ display: 'flex', alignItems: 'center' }} key={label}>
            <div style={{ display: 'flex', flexDirection: 'column', margin: '0 16px' }}>
              <div style={headerTextStyle}>{label}</div>
              <div style={bodyTextStyle}>{value}</div>
            </div>
          </div>
        ))}
      </ItemContainer>
    </Wrapper>
  );
};
